<template>
  <div>
    <transition name="modal">
      <div class="modal__mask">
        <div class="modal__wrapper">
          <div class="modal__container">
            <div class="modal__header">
              <slot name="header">
                <h5>{{ title }}</h5>
              </slot>
              <span role="button" @click="$emit('reject')"
                ><font-awesome-icon
                  icon="times"
                  transform="grow-4"
                ></font-awesome-icon
              ></span>
            </div>

            <div class="modal__body">
              <slot> </slot>
            </div>

            <div class="modal__footer">
              <slot name="footer">
                <button @click="$emit('reject')">Cancel</button>
                <button @click="$emit('accept')" :disabled="acceptDisabled">
                  {{ acceptText }}
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "Modal",
  props: {
    acceptText: { type: String, default: "OK" },
    acceptDisabled: { type: Boolean, default: false },
    title: String
  }
};
</script>
<style scoped>
.modal__mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.25);
  display: table;
  transition: opacity 0.3s ease;
}

.modal__wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal__container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  width: 500px;
  max-width: 95vw;
  height: 250px;
  margin: 0 auto;
  padding: 18px;
  background-color: white;
  border-radius: 2px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px,
    rgba(0, 0, 0, 0.22) 0px 15px 12px;
}

.modal__header {
  margin-top: 0;
  display: flex;
  justify-content: space-between;
  color: rgb(37, 36, 34);
}
.modal__body {
  flex-grow: 1;
  color: rgb(37, 36, 34);
  font-family: "Roboto";
}
/* :slotted(.modal__body) {
  flex-grow: 1;
}
:slotted(span) {
  font-family: "Roboto" !important;
  color: red;
} */

.modal__footer {
  display: flex;
  justify-content: end;
  gap: 6px;
}
.modal__footer button {
  border: 1px solid rgb(118, 118, 118, 0.75);
  border-radius: 2px;
  color: rgb(37, 36, 34);
  text-wrap: nowrap;
}
.modal__footer button:disabled {
  color: rgb(37, 36, 34, 0.25);
}
.modal__footer button:focus {
  outline: rgba(102, 179, 227, 0.75) auto 1px !important;
  outline-offset: 0px;
  z-index: 99;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 2.25s ease-in-out;
}

.modal-enter,
.modal-leave-to {
  opacity: 0.5;
}

:slotted(.modal__body button) {
  border: 1px solid rgb(118, 118, 118, 0.75);
  border-radius: 2px;
  color: rgb(37, 36, 34);
  text-wrap: nowrap;
}
</style>
